import React, { ReactNodeArray } from "react";
import { IsDefined } from "../../Generic/IsDefined";

interface Props {
  label: ReactNodeArray;
  metadata?: (string | number | null)[];
  onClick: () => void;
}

const SearchModalResult = ({ onClick, label, metadata: _metadata }: Props) => {
  return (
    <div onClick={onClick} className="SearchModalResult">
      <div className="__label">{label}</div>
      <IsDefined value={_metadata}>
        {(metadata) => <div className="__metadata">{metadata.join(" • ")}</div>}
      </IsDefined>
    </div>
  );
};

export default React.memo(SearchModalResult);
